export const FREE_PRICE = 'Free';

export const PLAN_STARTUP = 'startup_workspace';
export const PLAN_TEAMS = 'teams_workspace';
export const PLAN_TEAMS_PRO = 'pro_workspace';
export const PLAN_ENTERPRISE = 'enterprise_workspace';

export const ORGANIZATION_PLAN_FREE = 'individual_organization';
export const ORGANIZATION_PLAN_STARTER = 'starter_organization';
export const ORGANIZATION_PLAN_ENTERPRISE = 'enterprise_organization';
export const ORGANIZATION_PLAN_PRO = 'platform_pro';
export const ORGANIZATION_PLAN_PRO_SPANS = 'platform_pro_spans';

// THESE PLANS INCLUDE BOTH ORGANIZATION AND WORKSPACE
export const PAYMENT_PLANS = {
  [FREE_PRICE]: null,
  [PLAN_ENTERPRISE]: {
    priority: 3,
    prev: ORGANIZATION_PLAN_STARTER,
    plan: PLAN_ENTERPRISE,
    displayName: 'Enterprise',
    name: 'Enterprise',
    price: null,
    bulletsTitle: 'Includes:',
    bullets: [
      {
        label: 'Unlimited Private and Public Projects',
        withPadding: false
      },
      {
        label: 'Unlimited Teams and Members, Single Sign-On Enabled',
        withPadding: false
      },
      {
        label: 'Flexible Deployment – On-premises, VPC or Cloud',
        withPadding: false
      },
      {
        label: 'Model Management',
        withPadding: false
      },
      {
        label: 'Dedicated MLOps Support',
        withPadding: false
      },
      {
        label: 'Phone, Email and Dedicated Slack Channel',
        withPadding: false
      },
      {
        label: 'Support and Services SLAs',
        withPadding: false
      },
      {
        label: 'Hyperparameter Search',
        withPadding: false
      },
      {
        label: 'Artifacts',
        withPadding: false
      }
    ],
    label: 'Unlimited training hours',
    priceLabel: 'Contact Us',
    color: '#5154C3',
    hourPrice: 0,
    outdated: true
  },
  // ORGANIZATIONS
  [ORGANIZATION_PLAN_FREE]: {
    priority: 0,
    next: ORGANIZATION_PLAN_STARTER,
    plan: ORGANIZATION_PLAN_FREE,
    displayName: 'Free plan',
    name: 'Free',
    planBenefits: 'Perfect for individuals',
    paymentBullets: [
      {
        label: '1 platform user'
      },
      {
        label: 'Generous free tier'
      }
    ],
    paymentBulletsLLM: [
      {
        label: 'Unlimited team members'
      },
      {
        label: '10k traces per month'
      }
    ],
    price: 0,
    bulletsTitle: 'Includes:',
    bullets: [
      {
        label: 'Track and compare machine learning training runs',
        withPadding: false
      },
      {
        label: 'Dataset management and versioning',
        withPadding: false
      },
      {
        label: 'Model Registry',
        withPadding: false
      }
    ],
    bulletsLLM: [
      {
        label: 'LLM Tracing',
        withPadding: false
      },
      {
        label: 'Datasets and experiments',
        withPadding: false
      },
      {
        label: 'LLM-as-a-judge metrics',
        withPadding: false
      }
    ],
    priceLabel: '$0',
    priceDescription: 'free plan',
    color: '#FFB42E',
    hourPrice: 0,
    cta: 'Upgrade to Add Collaborators',
    outdated: false
  },
  [ORGANIZATION_PLAN_STARTER]: {
    priority: 2,
    next: ORGANIZATION_PLAN_STARTER,
    plan: ORGANIZATION_PLAN_STARTER,
    displayName: 'Starter plan',
    name: 'Starter',
    price: 50,
    bulletsTitle: 'Includes:',
    bullets: [
      'Up To 10 Members',
      'Unlimited Private and Public Projects',
      'Model Registry',
      'API Account',
      'Dedicated Slack Channel (Guaranteed SLA)',
      '500GB Storage Credits',
      'Hyperparameter Search',
      'Artifacts'
    ],
    label: '5,000 annual organization training hours',
    paymentBullets: [
      {
        label: '$1 / training hour beyond',
        highlighted: false
      }
    ],
    priceLabel: '$50',
    priceDescription: 'Per user/month',
    color: '#52AEA4',
    hourPrice: 1,
    outdated: true
  },
  [ORGANIZATION_PLAN_PRO]: {
    priority: 2,
    next: ORGANIZATION_PLAN_PRO,
    plan: ORGANIZATION_PLAN_PRO,
    displayName: 'Pro (legacy)',
    name: 'Pro (legacy)',
    price: 39,
    bulletsTitle: 'Includes everything in the Free plan plus:',
    bullets: [
      {
        label: 'Up to 10 users',
        withPadding: false
      },
      {
        label: 'Email support',
        withPadding: false
      },
      {
        label: 'Generous storage limits',
        withPadding: false
      }
    ],
    bulletsLLM: [
      {
        label: 'Generous usage limits',
        withPadding: false
      }
    ],
    planBenefits: 'Advanced collaboration for teams',
    paymentBullets: [
      {
        label: 'Up to 10 users'
      },
      {
        label: '1500 training hours included'
      }
    ],
    paymentBulletsLLM: [
      {
        label: 'Unlimited team members'
      },
      {
        label: '100k traces per month'
      }
    ],
    priceLabel: '$39',
    priceDescription: 'Per user/month',
    priceDescriptionLLM: 'Per month',
    color: '#52AEA4',
    hourPrice: 1,
    outdated: true
  },
  [ORGANIZATION_PLAN_PRO_SPANS]: {
    priority: 2,
    next: ORGANIZATION_PLAN_PRO,
    plan: ORGANIZATION_PLAN_PRO,
    displayName: 'Pro plan',
    name: 'Pro',
    price: 39,
    bulletsTitle: 'Includes everything in the Free plan plus:',
    bullets: [
      {
        label: 'Up to 10 users',
        withPadding: false
      },
      {
        label: 'Email support',
        withPadding: false
      },
      {
        label: 'Generous storage limits',
        withPadding: false
      }
    ],
    bulletsLLM: [
      {
        label: 'Pay-as-you-go pricing for: ',
        withPadding: false
      },
      {
        label: 'Additional monthly spans',
        withPadding: true
      },
      {
        label: 'Longer data retention',
        withPadding: true
      }
    ],
    planBenefits: 'Advanced collaboration for teams',
    paymentBullets: [
      {
        label: 'Up to 10 users'
      },
      {
        label: '1500 training hours included'
      }
    ],
    paymentBulletsLLM: [
      {
        label: 'Unlimited team members'
      },
      {
        label: '100k spans per month'
      },
      {
        label: '60-day data retention'
      }
    ],
    priceLabel: '$39',
    priceDescription: 'Per user/month',
    priceDescriptionLLM: 'Per month',
    color: '#52AEA4',
    hourPrice: 1,
    outdated: false
  },
  [ORGANIZATION_PLAN_ENTERPRISE]: {
    priority: 3,
    plan: PLAN_ENTERPRISE,
    displayName: 'Enterprise plan',
    name: 'Enterprise',
    price: null,
    priceDescription: 'Contact us',
    bulletsTitle: 'Includes everything in the Pro plan plus:',
    bullets: [
      {
        label: 'Flexible deployments',
        withPadding: false
      },
      {
        label: 'Model production monitoring',
        withPadding: false
      },
      {
        label: 'Service accounts and view-only users',
        withPadding: false
      },
      {
        label: 'Single sign on',
        withPadding: false
      },
      {
        label: 'Dedicated support and SLAs',
        withPadding: false
      }
    ],
    bulletsLLM: [
      {
        label: 'Flexible deployments',
        withPadding: false
      },
      {
        label: 'Service accounts and view-only users',
        withPadding: false
      },
      {
        label: 'Single sign on',
        withPadding: false
      },
      {
        label: 'Dedicated support and SLAs',
        withPadding: false
      }
    ],
    planBenefits: 'Security, compliance & flexible deployments',
    paymentBullets: [
      {
        label: 'Unlimited users'
      },
      {
        label: 'Unlimited training hours'
      }
    ],
    paymentBulletsLLM: [
      {
        label: 'Unlimited team members'
      },
      {
        label: 'Unlimited traces'
      }
    ],
    label: 'Unlimited training hours',
    color: '#5154C3',
    hourPrice: 1,
    outdated: false
  },
  // the old workspaces
  [PLAN_STARTUP]: {
    priority: 1,
    plan: PLAN_STARTUP,
    displayName: 'Startup Workspace',
    name: 'Startup Workspace',
    price: 39,
    bullets: [
      {
        label: 'Unlimited public & private projects',
        withPadding: false
      },
      {
        label: 'Bayesian hyperparameter optimization',
        withPadding: false
      },
      {
        label: 'REST API Access',
        withPadding: false
      }
    ],
    priceLabel: '$39',
    priceDescription: 'Per user/month',
    hourPrice: 0,
    color: '#52AEA4',
    outdated: true
  },
  [PLAN_TEAMS]: {
    priority: 1,
    next: PLAN_TEAMS_PRO,
    plan: PLAN_TEAMS,
    displayName: 'Teams Workspace',
    displayNameAcademic: 'Teams - Academic',
    name: 'teams',
    price: 179,
    bulletsTitle: 'Includes:',
    bullets: [
      {
        label: 'Unlimited Private and Public Projects',
        withPadding: false
      },
      {
        label: 'Up To 5 Members',
        withPadding: false
      },
      {
        label: 'REST API Access',
        withPadding: false
      },
      {
        label: 'Community Slack and Email Support',
        withPadding: false
      },
      {
        label: '250GB Storage Credits',
        withPadding: false
      },
      {
        label: 'Hyperparameter Search',
        withPadding: false
      },
      {
        label: 'Artifacts',
        withPadding: false
      }
    ],
    priceLabel: '$179',
    priceDescription: 'Per user/month',
    color: '#1ab1a4',
    hourPrice: 0,
    outdated: true
  },
  [PLAN_TEAMS_PRO]: {
    priority: 2,
    prev: PLAN_TEAMS,
    next: PLAN_TEAMS_PRO,
    plan: PLAN_TEAMS_PRO,
    displayName: 'Teams Pro Workspace',
    displayNameAcademic: 'Teams - Academic',
    name: 'teams pro',
    price: 249,
    bulletsTitle: 'Includes:',
    bullets: [
      {
        label: 'Unlimited Private and Public Projects',
        withPadding: false
      },
      {
        label: 'Up To 5 Members',
        withPadding: false
      },
      {
        label: 'Rest API Access',
        withPadding: false
      },
      {
        label: 'Model Management',
        withPadding: false
      },
      {
        label: 'API Account',
        withPadding: false
      },
      {
        label: 'Dedicated Slack Channel (Guaranteed SLA)',
        withPadding: false
      },
      {
        label: '500GB Storage Credits',
        withPadding: false
      },
      {
        label: 'Hyperparameter Search',
        withPadding: false
      },
      {
        label: 'Artifacts',
        withPadding: false
      }
    ],
    priceLabel: '$249',
    priceDescription: 'Per user/month',
    color: '#ff594c',
    hourPrice: 0,
    outdated: true
  }
};

export const PLAN_DISPLAY_NAME = {
  [PLAN_STARTUP]: {
    display: 'Startup Workspace',
    name: 'startup',
    plan: PLAN_STARTUP
  },
  [PLAN_TEAMS]: {
    display: 'Teams Workspace',
    name: 'teams',
    plan: PLAN_TEAMS
  },
  [PLAN_TEAMS_PRO]: {
    display: 'Teams Pro Workspace',
    name: 'pro',
    plan: PLAN_TEAMS_PRO
  },
  [ORGANIZATION_PLAN_ENTERPRISE]: {
    display: 'Enterprise Workspace',
    name: 'enterprise',
    plan: ORGANIZATION_PLAN_ENTERPRISE
  },
  [ORGANIZATION_PLAN_STARTER]: {
    display: 'Starter',
    name: 'Starter',
    plan: ORGANIZATION_PLAN_STARTER
  },
  [ORGANIZATION_PLAN_PRO]: {
    display: 'Pro',
    name: 'Pro',
    plan: ORGANIZATION_PLAN_PRO
  },
  [ORGANIZATION_PLAN_PRO_SPANS]: {
    display: 'Pro Spans',
    name: 'Pro Spans',
    plan: ORGANIZATION_PLAN_PRO_SPANS
  }
};

export const FREE_PLANS = [ORGANIZATION_PLAN_FREE];

export const PLANS_WITH_TRIAL = [
  ORGANIZATION_PLAN_STARTER,
  ORGANIZATION_PLAN_PRO_SPANS
];

export const PAID_PLANS = [
  PLAN_DISPLAY_NAME[PLAN_STARTUP].plan,
  PLAN_DISPLAY_NAME[PLAN_TEAMS].plan,
  PLAN_DISPLAY_NAME[PLAN_TEAMS_PRO].plan,
  PLAN_DISPLAY_NAME[ORGANIZATION_PLAN_ENTERPRISE].plan,
  PLAN_DISPLAY_NAME[ORGANIZATION_PLAN_STARTER].plan,
  PLAN_DISPLAY_NAME[ORGANIZATION_PLAN_PRO].plan,
  PLAN_DISPLAY_NAME[ORGANIZATION_PLAN_PRO_SPANS].plan
];
